angular.module('qkr.department')
    .controller('departmentController', function departmentController($scope, $rootScope, $routeSegment, $uibModal,
                                                                      messageService, FormHelper, departmentService,
                                                                      menuService, gettextCatalog, appConfig,
                                                                      departments, paymentConfigList) {
        const formHelper = new FormHelper($scope);

        const vm = $scope;

        vm.paymentConfigList = paymentConfigList; // TODO why is this on vm? weird
        vm.departments = departments;
        vm.isSupplier = (appConfig.businessCategory === 'Supplier');
        vm.isDepartmentManager = appConfig.isDepartmentManager;

        vm.menuName = ''; // TODO what is this crazy thing, the template does not use it... why on vm?

        vm.createDepartment = () => {
            showEditDepartment(false);
        };

        vm.editDepartment = (department) => {
            const editDepartment = angular.copy(department);
            showEditDepartment(true, editDepartment);
        };

        vm.hideOrShowDepartment = (department) => {
            department.offline = !department.offline;
            departmentService.updateDepartmentPost(department).then(reloadRoute);
        };

        vm.deleteDepartment = (department) => {
            vm.modalOpen = true;
            const modalInstance = $uibModal.open({
                template: require('../../templates/common/modalDialog.html'),
                controller: 'commonModalDialogController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    title() {
                        return gettextCatalog.getString('Delete Department') + ' ';
                    },
                    confirmButtonName() {
                        return gettextCatalog.getString('Delete') + ' ';
                    },
                    confirmMsg() {
                        return gettextCatalog.getString('Are you sure you want to delete') + department.name + ' ?';
                    },
                    multiMsgArray() {
                        return [];
                    }
                }
            });

            modalInstance.result.then(result => {
                vm.modalOpen = false;
                if (result === 'ok') {
                    departmentService.deleteDepartmentPost(department).then(reloadRoute,
                        (promise) => {
                            if (promise.data.exception) {
                                messageService.error(promise.data.exception);
                            }
                        });
                }
            });
        };

        vm.openMenu = ($event, departmentId, menu, departmentReadOnly) => {

            const options = {
                menuViewReadonly: departmentReadOnly,
                allowedCustomizeMenuItems: true,
                allowedCreateMenuItems: true
            };

            const modalInstance = $uibModal.open({
                template: require('../../templates/menu/view_menu.html'),
                controller: 'menuController',
                windowClass: 'view-menu',
                animation: false,
                resolve: {
                    options() {
                        return options;
                    },
                    menuId() {
                        return menu.id;
                    },
                    departmentId() {
                        return departmentId;
                    }
                }
            });

            modalInstance.result
                .then(() => reloadRoute());
        };

        vm.createMenu = ($event, departmentId, menuName) => {
            departmentService.setCurrentDepId(departmentId);

            const warningModal = departmentService.showMultipleMenusInDeptWarning();

            vm.menuName = '';

            if (warningModal) {
                warningModal.result.then((result) => {
                    if (result && result === 'ok') {
                        departmentService.showCreateMenuModal(menuName).result.then((newMenu) => {
                            vm.openMenu($event, departmentId, newMenu, false);
                            reloadRoute();
                        });
                    }
                });
            } else {
                departmentService.showCreateMenuModal(menuName).result.then((newMenu) => {
                    vm.openMenu($event, departmentId, newMenu, false);
                    reloadRoute();
                });
            }
        };

        vm.editMenuSettings = (selectedMenu, departmentId) => {
            departmentService.setSelectedDepartmentId(departmentId);
            menuService.setCurrentMenuId(selectedMenu.id);
            menuService.loadMenu(selectedMenu.id).then(promise => {
                const modalInstance = $uibModal.open({
                    template: require('../../templates/menu/editMenu.html'),
                    controller: 'MenuEditController',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        menu() {
                            return promise;
                        },
                        isNewMenu() {
                            return false;
                        },
                        isSharedMenu() {
                            return false;
                        }
                        ,
                        existingMenuTypes() {
                            return [];
                        }

                    }
                });

                modalInstance.result.then(() => {
                    reloadRoute();
                });
            });
        };

        // Delete the menu
        vm.deleteMenu = (selectedMenu, departmentId) => {
            departmentService.setSelectedDepartmentId(departmentId);

            const confMsg = gettextCatalog.getString('Deleting parts of Qkr! may have a negative impact on your ' +
                'ability to generate reports in future and other unintended consequences. We strongly recommend you ' +
                'use Hide rather than Delete with the Qkr! Store Manager. Are you sure you still wish to proceed ' +
                'with this Delete command?');

            const modalInstance = $uibModal.open({
                template: require('../../templates/common/modalDialog.html'),
                controller: 'commonModalDialogController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    title() {
                        return gettextCatalog.getString('Delete Menu');
                    },
                    confirmButtonName() {
                        return gettextCatalog.getString('Confirm');
                    },
                    confirmMsg() {
                        return confMsg;
                    },
                    multiMsgArray() {
                        return [];
                    }
                }
            });

            modalInstance.result.then((result) => {
                if (result === 'ok') {
                    menuService.deleteMenu(selectedMenu).then(promise => {
                        removeMenuCallback(promise);
                    }, (promise) => {
                        removeMenuCallback(promise);
                    });
                }
            });
        };

        vm.updateMenuOrder = (department, evt, ui) => {
            const oldIndex = ui.item.sortable.index;
            const newIndex = ui.item.sortable.dropindex;

            const prodGroup = department.prodGroups[oldIndex];

            departmentService.moveProductGroup(department.id, prodGroup.id, newIndex);
        };

        // Disable or enable a product by clicking the button in the list
        vm.disableOrEnableMenu = (selectedMenu, departmentId) => {
            departmentService.setSelectedDepartmentId(departmentId);

            const menu = angular.copy(selectedMenu);
            const action = selectedMenu.offline ? 'show' : 'hide';
            const extra = selectedMenu.offline ? '' : 'It will no longer be displayed on the phone.';

            const confMsg = gettextCatalog.getString('Are you sure you want to') + ' ' + action + ' \'' +
                selectedMenu.name + '\'? ' + extra;

            const title = selectedMenu.offline ? 'Show Menu' : 'Hide Menu';

            const modalInstance = $uibModal.open({
                template: require('../../templates/common/modalDialog.html'),
                controller: 'commonModalDialogController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    title() {
                        return title;
                    },
                    confirmButtonName() {
                        return 'Confirm';
                    },
                    confirmMsg() {
                        return confMsg;
                    },
                    multiMsgArray() {
                        return [];
                    }
                }
            });

            modalInstance.result.then((result) => {
                if (result === 'ok') {
                    menu.offline = !menu.offline;
                    menuService.updateMenu(menu).then(promise => {
                        updateMenuCallback(promise);
                        reloadRoute();
                    }, (promise) => {
                        updateMenuCallback(promise);
                        reloadRoute();
                    });
                }
            });
        };

        // Handle response from attempted save
        function updateMenuCallback(response) {
            const r = formHelper.handleResponse(response);
            if (r.isSuccess()) {
                menuService.loadMenus(departmentService.getCurrentDepId()).then(menuItemsResponse => {
                    departmentService.clearDepartmentCache();
                    $rootScope.$broadcast('newMenus', menuItemsResponse);
                    // Reload the dashboard info
                });
                $rootScope.$broadcast('reloadDashboard');

                messageService.saveAlert(gettextCatalog.getString('Changes Saved'));
            } else {
                messageService.error(gettextCatalog.getString('Could not update. Please try again.'));
            }
        }

        function showEditDepartment(isEdit, department) {
            vm.modalOpen = true;
            const modalInstance = $uibModal.open({
                template: require('../../department/templates/department.html'),
                controller: 'DepartmentManagmentModalDialogController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    isEdit() {
                        return isEdit;
                    },
                    department() {
                        return department;
                    },
                    paymentConfigList() {
                        return vm.paymentConfigList;
                    }
                }
            });

            modalInstance.result.then((result) => {
                vm.modalOpen = false;
                if (result === 'done') {
                    reloadRoute();
                }
            });
        }

        function reloadRoute() {
            $routeSegment.chain[0].reload();
        }

        // Handle response from attempted save
        function removeMenuCallback(response) {
            const r = formHelper.handleResponse(response);
            if (r.isSuccess()) {
                menuService.loadMenus(departmentService.getCurrentDepId()).then((menuItemsResponse) => {
                    departmentService.clearDepartmentCache();
                    $rootScope.$broadcast('newMenus', menuItemsResponse);
                    // Reload the dashboard info
                });
                $rootScope.$broadcast('reloadDashboard');

                reloadRoute();

                messageService.saveAlert(gettextCatalog.getString('Menu Deleted'));
            } else {
                messageService.error(gettextCatalog.getString('Could not remove. Please try again.'));
            }
        }
    }
);





// WEBPACK FOOTER //
// ./src/department/controllers/department.controller.js